import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, Loading, Tag } from "@/components/common";
import { Handshake, Plus } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Licensing() {
  const { data: deals, loading } = useFetch("/licensing");
  if (loading || !deals) return <Loading />;

  return (
    <div>
      <PageHeader icon={Handshake} title="Licensing Centre"
        subtitle="Future-ready PinPilot IP licensing. Track partners, categories, territories, royalties, minimum guarantees, reported sales and contract files."
        actions={<button data-testid="add-deal" onClick={() => toast("Licensing deal entry will be available after partner setup.")} className="inline-flex items-center gap-2 rounded-full bg-magic px-4 py-2 text-sm font-semibold text-black"><Plus size={16} weight="bold" /> New Deal</button>} />

      <div className="space-y-4">
        {deals.map((d) => (
          <Panel key={d.id} data-testid={`deal-${d.id}`}>
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="font-display text-lg font-bold text-white">{d.partner}</h3>
                <div className="flex gap-2 mt-1"><Tag>{d.category}</Tag><Tag>{d.character}</Tag><Tag>{d.territory}</Tag></div>
              </div>
              <Tag>{d.status}</Tag>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4 text-sm">
              <Cell label="Start" value={d.start} /><Cell label="End" value={d.end} />
              <Cell label="Royalty" value={d.royalty} /><Cell label="Min guarantee" value={d.min_guarantee} />
              <Cell label="Reported sales" value={d.reported_sales} /><Cell label="Royalty due" value={d.royalty_due} />
            </div>
          </Panel>
        ))}
      </div>
    </div>
  );
}

function Cell({ label, value }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-zinc-500">{label}</div>
      <div className="text-white mt-0.5">{value}</div>
    </div>
  );
}
